// Attribute stamped on the hidden plan-warmup container (see
// PlanPrerenderWarmup). Its subtree is a `display:none` pre-render of every
// plan's primary chain, mounted after first paint so selecting/hovering a plan
// is instant instead of paying the mount cost on click.
//
// The subtree is a full clone of real playbook content, so it carries the same
// DOM markers the page's global scans look for — [data-chart-date],
// [data-legend-label], [data-branch-choice-ids], [data-playbook-timeline-
// segment], <details>, year headings. Every one of those scans must skip this
// subtree or the warmup would corrupt the HUD date, the legend, the years rail,
// and the choice-point scroll lock. Callers exclude it via
// isInsidePlanPrerenderWarmup (per-element) or the :not() selector suffix below
// (querySelectorAll).
export const PLAN_PRERENDER_WARMUP_ATTR = "data-plan-prerender-warmup"

// querySelectorAll suffix that drops any element inside the warmup subtree.
// Append to an existing selector, e.g.
//   `[data-chart-date]${PLAN_PRERENDER_WARMUP_EXCLUDE_SELECTOR}`
export const PLAN_PRERENDER_WARMUP_EXCLUDE_SELECTOR =
  `:not([${PLAN_PRERENDER_WARMUP_ATTR}] *)`

// True when `element` sits inside (or is) the warmup subtree. Use for scans
// that iterate elements individually rather than via a single selector.
export const isInsidePlanPrerenderWarmup = (element: Element | null): boolean =>
  !!element?.closest(`[${PLAN_PRERENDER_WARMUP_ATTR}]`)
